import pluxeeLogo from "../assets/Pluxee_Logo.png";
import "./PluxeeInfoModal.css";

const PluxeeInfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="plx-overlay"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        className="plx-backdrop"
        style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)" }}
      />
      <div
        className="plx-card"
        style={{
          position: "relative",
          zIndex: 1,
          background: "#ffffff",
          borderRadius: 18,
          width: "100%",
          maxWidth: 260,
          padding: "24px 20px 20px",
          boxShadow: "0 8px 28px rgba(0,0,0,0.2)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <img
          src={pluxeeLogo}
          alt="Pluxee"
          className="plx-logo"
          style={{ width: 100, height: "auto", objectFit: "contain", marginBottom: 16 }}
        />

        <p
          className="plx-desc"
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#1f2937",
            lineHeight: 1.45,
            margin: "0 0 32px",
          }}
        >
          Pluxee card payments now accepted.
        </p>

        <button
          className="plx-got-it-btn"
          onClick={onClose}
          style={{
            width: "auto",
            minWidth: 110,
            padding: "9px 24px",
            background: "#6b8e23",
            color: "#ffffff",
            fontSize: 13,
            fontWeight: 700,
            border: "none",
            borderRadius: 10,
            cursor: "pointer",
            letterSpacing: "0.3px",
            marginTop:16
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default PluxeeInfoModal;
